import React, { Component } from 'react';
import axios from 'axios';


import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
//import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import {  Button} from 'reactstrap';
import '../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { FaSearch, FaRegSave, FaCheck, FaCheckDouble, FaEdit } from 'react-icons/fa';
import { FiEdit3 } from 'react-icons/fi'; 
import { AiOutlineFileSearch } from 'react-icons/ai'; 

import { MdAddCircleOutline, MdClose, MdTextsms} from 'react-icons/md'; //GoIssueClosed
import { GoIssueClosed } from 'react-icons/go'; //GoIssueClosed
import { FaFileDownload } from 'react-icons/fa'; //GoIssueClosed


import { Link } from 'react-router-dom';  
import AuthorizeRoute from './api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';
import ModalsAlert from './ModalsAlert'

function afterSearch(searchText, result) {
 // console.log('Your search text is ' + searchText);
 // console.log('Result is:');
  for (let i = 0; i < result.length; i++) {
    console.log('Fruit: ' + result[i].id + ', ' + result[i].name + ', ' + result[i].price);
  }
}



export default class VerCreditos extends Component {
  constructor(props) {
    super(props);
      this.state = {
          business: [],
          EstadoSolicitudEnProceso: false,
          mensajeModal: '',
          usuario:'',
          modal: false
      };
    this.options = {
      defaultSortName: 'fechaModificacion',  // default sort column name
      defaultSortOrder: 'desc'  // default sort order
    };
     
      this.CerrarModal = this.CerrarModal.bind(this)
      this.sendDataServer = this.sendDataServer.bind(this)
    
  }

    sendDataServer = () => {

     
     //   console.log('validation successful')
      
    }
    CerrarModal = () => {
        this.setState({
            modal: false

        })
    }
    componentDidMount() {
    
    this._subscription = authService.subscribe(() => this.populateState2());
    this.populateState2();
    //   console.log(authService);
//




        axios.get('GetSaS')
            .then(response => {
         
                var azure = response.data.split('@')
                window.sas = azure[0];
                window.account = azure[1];
                var validador = window.checkParameters()
                if (validador == true) {
                window.getBlobService()
                window.viewContainer(azure[2])
                 }
            })
            .catch(function (error) {
                console.log(error);
            })

  
  }

  async populateState2() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
     //    console.log(user)
      if (user !== null) {
          this.getCreditos(user.sub)
      } else {
          this.props.history.push('/addCredito')
      }
   
  }
    getCreditos(idEmpleado){
        axios.get('/Api/Credito/CreditodetailsUsuario?idEmpleado=' + idEmpleado)
      .then(response => {
          this.setState({ business: response.data });
          this.setState({ usuario: idEmpleado });

          
      //       console.log(this.state)

       //      console.log(this.verificarSolicitudes(response))
      })
      .catch(function (error) {
        console.log(error);
      })
  }

    verificarSolicitudes(response) {
      //     console.log(response.data[0])
        for (var i = 0; i < response.data.length; i++) {
         //      console.log(response.data[i].estado) // <a onClick={window.refreshBlobListIdElement(row.usuarioID, row.Id, 5, 1)} >aca</a></div>
            if (response.data[i].estado == "GUARDADO" || response.data[i].estado == "EN REVISIÓN" || response.data[i].estado == "Requiere cambios"
                || response.data[i].estado == "EN REVISIÓN FIRMA Y SELFIE" || response.data[i].estado == "CONTRATO ANEXADO"
                || response.data[i].estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {
                this.setState({ EstadoSolicitudEnProceso:true})
                return true;
            }
               
        }
        return false;
        
    }
    ModalAlerta = (e) => {

        console.log(e.target.value)

        console.log(this.state.usuario)

        window.refreshBlobListIdElement(this.state.usuario, e.target.value, 5, 1);
    }
  
  CrearSolicitud = () => {


      this.props.history.push('/addCredito')

    
  }

    alerta(comments){

        this.setState({
            mensajeModal: comments

        })

        this.setState({
            modal: true

        })
       
      }
  buttonFormatter(cell, row) {
      
    //   console.log(cell)
    //   console.log(row)
    var enlace =""
      if (row.estado == "GUARDADO" ) {
      enlace = "/EditCredito/";


          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FiEdit3 /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FiEdit3 /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>
              </div>;

          }


        
      }
      else if (row.estado == "DISPERSADO") {
          enlace = "/solicitudDetail/"

          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>&nbsp;
                  <Button onClick={this.ModalAlerta} value={row.id} title='Contrato'><FaFileDownload/></Button>
                  <a hidden='true' id={'abrir' + row.id} download target="_blank">a</a>
                  <div hidden='true' id={"result" + row.id}></div>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>&nbsp;
                  <Button onClick={this.ModalAlerta} value={row.id} title='Contrato'><FaFileDownload /></Button>
                  <div hidden={true} id={"result" + row.id}></div>
                  <a hidden={true}  id={'abrir' + row.id} download target="_blank">a</a>
              </div>;

          }

      }

     
      else if (row.estado == "CONTRATO ANEXADO") {
          enlace = "/solicitudDetail/"

          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>
              </div>;

          }

      }
      else if (row.estado == "RECHAZAR SOLICITUD" || row.estado == "EN REVISIÓN FIRMA Y SELFIE" ) {
          enlace = "/solicitudDetail/";
         

          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>
              </div>;

          }


      }

      else if (row.estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {
          enlace = "/solicitudDetail/";


          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>
              </div>;

          }


      }

      else if (row.estado == "REQUIERE CAMBIOS" || row.estado == "INCOMPLETA" ) {
          enlace = "/EditCredito/";

          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FiEdit3 /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FiEdit3 /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>
              </div>;

          }


      }
          //
     
    
      else {
      enlace = "/solicitudDetail/";
          
          var comments = "sin comentarios"
          var disabled = "disabled"
          if (row.comentario !== null && row.comentario !== "undefined" && row.comentario !== "") {
              comments = row.comentario


              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments}><MdTextsms /></Button>
              </div>;

          } else {
              return <div>
                  <Link className="btn btn-success" to={enlace + row.id} title="Ver solicitud"><FaSearch /></Link>&nbsp;
                <Button onClick={() => this.alerta(comments)} value={comments} disabled title="Sin comentarios"><MdTextsms /></Button>
              </div>;

          }

              }
              
    
  }
    ButtonEstado(cell, row) {

      //     console.log(cell)
     //      console.log(row)
        var enlace = ""
        if (row.estado == "EN REVISIÓN") {


            return <div className="alinearCelda">

                <Button className="btn btn-info" disabled title={row.estado}><FiEdit3 /></Button>
            </div>;


            //
        }
        else if (row.estado == "DISPERSADO") {
            return <div className="alinearCelda">

                <Button className="btn btn-success" disabled title={row.estado}><FaCheckDouble /></Button>
            </div>;

        }
        else if (row.estado == "CONTRATO ANEXADO") {
            return <div className="alinearCelda">

                <Button className="btn btn-success" disabled title={row.estado}><FaCheck /></Button>
            </div>;

        }
        else if (row.estado == "RECHAZAR SOLICITUD") {

            return <div className="alinearCelda">
                <Button className="btn btn-danger" disabled title={row.estado}><MdClose /></Button>
            </div>;

        }
        else if (row.estado == "REQUIERE CAMBIOS" || row.estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE" || row.estado == "INCOMPLETA") {

            return <div className="alinearCelda">

                <Button className="btn btn-warning" disabled title={row.estado}><GoIssueClosed /></Button>
            </div>;
        }
        else if (row.estado == "EN REVISIÓN FIRMA Y SELFIE") {


            return <div className="alinearCelda">

                <Button className="btn btn-info" disabled title={row.estado}><AiOutlineFileSearch /></Button>
            </div>;


            //
        }
        else if (row.estado == "GUARDADO") {

            return<div className = "alinearCelda">

                <Button className="btn btn-primary" disabled title={row.estado} > <FaRegSave /></Button >
            </div >;
    }
        

        else {

            return <div className="alinearCelda">

                <Button className="btn btn-secondary" disabled title={row.estado}><FaSearch /></Button>
            </div>;
        }


    }

  MontoFormatter(cell, row) {
    let numero = new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN"
    }).format(row.montocredito)
    //   console.log(numero)

    return <div>{numero} </div>;

  }
  Montodate(cell, row) {
    {
    //     console.log(row.fechaModificacion)
      var date = new Date(row.fechaModificacion);

      var fecha = new Intl.DateTimeFormat("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).format(date)
    }
    return <div>{fecha} </div>;

    }
   


    MensajeSolicitudEnProceso = () => {
       //    console.log(this)
        if (this.state.EstadoSolicitudEnProceso == true) {
          
            this.setState({
                mensajeModal: "Usted ya tiene una solicitud en proceso. Solo se permite una solicitud activa a la vez."

            })

            this.setState({
                modal: true

            })
        } else {
            this.props.history.push('/addCredito')
        }

    }

    render() {
      function filterdate(cell, row) {
          // just return type for filtering or searching.
       //      console.log(cell.type)
          var date = new Date(row.fechaModificacion);

          var fecha = new Intl.DateTimeFormat("es-MX", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
          }).format(date)
          return fecha;
      }
      function filterMonto(cell, row) {
          // just return type for filtering or searching.
          let numero = new Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN"
          }).format(row.montocredito)
       //      console.log(numero)
          return numero;
      }


     


    return (
      <div className="TablaSolicitudes">
        
        <h2 className="PageHeading" >Solicitudes</h2>
        <div className="Row">
                <a className="nuevaSolicitud" onClick={this.MensajeSolicitudEnProceso}>Nueva solicitud de crédito</a>
            </div>
            <hr />
       <BootstrapTable data={this.state.business} search={true} searchPlaceholder={'Buscador'} options={this.options} pagination striped hover condensed>
          <TableHeaderColumn isKey dataField='id' hidden={true} width='150' dataSort={true}>ID</TableHeaderColumn>
          <TableHeaderColumn dataField='comentario' hidden={true} width='150' dataSort={false}>ID</TableHeaderColumn>
                <TableHeaderColumn dataField='fechaModificacion' width='185' filterValue={filterdate}  dataSort={true} dataFormat={this.Montodate.bind(this)}>Fecha de modificación</TableHeaderColumn>
                <TableHeaderColumn dataField='montocredito' width='120' filterValue={filterMonto}  dataSort={true} dataFormat={this.MontoFormatter.bind(this)}>Monto</TableHeaderColumn>
          <TableHeaderColumn dataField='estado' width='90' dataFormat={this.ButtonEstado.bind(this)} dataSort={true}>Estado</TableHeaderColumn>
          <TableHeaderColumn dataField="button" width='150' dataFormat={this.buttonFormatter.bind(this)}>Acción</TableHeaderColumn>

            </BootstrapTable> 
            <ModalsAlert state={this.state} CerrarModal={this.CerrarModal} isOpen={this.state.modal} sendDataServer={this.sendDataServer} />
      </div>
   
    );
  }
}



        //<table className="table table-striped" style={{ marginTop: 10 }}>
        //  <thead>
        //    <tr>
        //      <th>Fecha de modificación</th>
        //      <th>Monto solicitado</th>
        //      <th>Estado</th>          
        //      <th colSpan="4">Accion</th>
        //    </tr>
        //  </thead>
        //  <tbody>
        //    {this.tabRow()}
        //  </tbody>
        //</table>
